import { IConsentForm } from '@common/models/forms/ConsentForm';
import { VisitConsentClientRequest } from './VisitConsentClientRequest';
import { VisitConsentDentalExtractionRequest } from './VisitConsentDentalExtractionRequest';
import { VisitConsentEuthanasiaRequest } from './VisitConsentEuthanasiaRequest';
import { VisitConsentSurgeryRequest } from './VisitConsentSurgeryRequest';
import { VisitConsentTreatmentRequest } from './VisitConsentTreatmentRequest';

export interface ISignAndStoreConsentRequest {
  visitPublicId: string;
  consentTypePublicId: string;
  signatureBase64Encoded: string;
  visitConsentEuthanasiaRequest?: VisitConsentEuthanasiaRequest;
  visitConsentClientRequest?: VisitConsentClientRequest;
  visitConsentDentalExtractionRequest?: VisitConsentDentalExtractionRequest;
  visitConsentTreatmentRequest?: VisitConsentTreatmentRequest;
  visitConsentSurgeryRequest?: VisitConsentSurgeryRequest;
}

export class SignAndStoreConsentRequest implements ISignAndStoreConsentRequest {
  visitPublicId: string;
  consentTypePublicId: string;
  signatureBase64Encoded: string;
  visitConsentEuthanasiaRequest?: VisitConsentEuthanasiaRequest;
  visitConsentClientRequest?: VisitConsentClientRequest;
  visitConsentDentalExtractionRequest?: VisitConsentDentalExtractionRequest;
  visitConsentTreatmentRequest?: VisitConsentTreatmentRequest;
  visitConsentSurgeryRequest?: VisitConsentSurgeryRequest;

  constructor(params: ISignAndStoreConsentRequest) {
    this.visitPublicId = _.defaultTo(params.visitPublicId, '');
    this.consentTypePublicId = _.defaultTo(params.consentTypePublicId, '');
    this.signatureBase64Encoded = _.defaultTo(
      params.signatureBase64Encoded,
      '',
    );
    this.visitConsentEuthanasiaRequest = params.visitConsentEuthanasiaRequest
      ? new VisitConsentEuthanasiaRequest(params.visitConsentEuthanasiaRequest)
      : undefined;
    this.visitConsentClientRequest = params.visitConsentClientRequest
      ? new VisitConsentClientRequest(params.visitConsentClientRequest)
      : undefined;
    this.visitConsentDentalExtractionRequest =
      params.visitConsentDentalExtractionRequest
        ? new VisitConsentDentalExtractionRequest(
            params.visitConsentDentalExtractionRequest,
          )
        : undefined;
    this.visitConsentTreatmentRequest = params.visitConsentTreatmentRequest
      ? new VisitConsentTreatmentRequest(params.visitConsentTreatmentRequest)
      : undefined;
    this.visitConsentSurgeryRequest = params.visitConsentSurgeryRequest
      ? new VisitConsentSurgeryRequest(params.visitConsentSurgeryRequest)
      : undefined;
  }

  static ParseSignAndStoreConsentRequest(
    visitPublicId: string,
    consentTypePublicId: string,
    signatureBase64Encoded: string,
    formData?: IConsentForm,
  ): SignAndStoreConsentRequest {
    return {
      signatureBase64Encoded,
      visitPublicId,
      consentTypePublicId,
      visitConsentEuthanasiaRequest: formData?.euthanasiaConsentForm
        ? new VisitConsentEuthanasiaRequest(formData.euthanasiaConsentForm)
        : undefined,
      visitConsentClientRequest: formData?.clientConsentForm
        ? new VisitConsentClientRequest(formData.clientConsentForm)
        : undefined,
      visitConsentDentalExtractionRequest: formData?.dentalExtractionConsentForm
        ? new VisitConsentDentalExtractionRequest(
            formData.dentalExtractionConsentForm,
          )
        : undefined,
      visitConsentTreatmentRequest: formData?.treatmentConsentForm
        ? new VisitConsentTreatmentRequest(formData.treatmentConsentForm)
        : undefined,
      visitConsentSurgeryRequest: formData?.surgeryConsentForm
        ? new VisitConsentSurgeryRequest(formData.surgeryConsentForm)
        : undefined,
    };
  }
}
